import { render, staticRenderFns } from "./ClientContactTab.vue?vue&type=template&id=a947de70&scoped=true"
import script from "./ClientContactTab.vue?vue&type=script&lang=ts"
export * from "./ClientContactTab.vue?vue&type=script&lang=ts"
import style0 from "./ClientContactTab.vue?vue&type=style&index=0&id=a947de70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a947de70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a947de70')) {
      api.createRecord('a947de70', component.options)
    } else {
      api.reload('a947de70', component.options)
    }
    module.hot.accept("./ClientContactTab.vue?vue&type=template&id=a947de70&scoped=true", function () {
      api.rerender('a947de70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/components/ClientContactTab.vue"
export default component.exports